export default {
    "appName": "Legacy branding",
    "appEmail": "business@legacybrandingco.com",
    "domain": process.env.NODE_ENV === 'production' ? "https://www.legacybrandingco.com" : "http://127.0.0.1:8000",
    "title": "Legacy branding | Platform Design Agency for Businesses",
    "shortDesc": "Platform Design Agency for Businesses",
    "description": "Legacy branding is a platform design agency for businesses, connecting modern visual designers with you. We are the best place to get the pro designers and creative experts competing to create awesome designs for you!",
    "localUserKey" : "ioqpzxisjdffrydogkxybqhmboy",
}
